import { createSlice } from "@reduxjs/toolkit";

const userActivitySlice = createSlice({
  name: "userActivity",
  initialState: {
    isLoading: false,
    realtimeStats: null,
    hourlyStats: [],
    dailyStats: [],
    monthlyStats: [],
    peakHours: [],
    heatmapStats: [],
    onlineAdmins: [],
    onlineUsers: [],
    onlineAdminTotal: 0,
    onlineUserTotal: 0,
  },
  reducers: {
    getRealtimeStatsRequest(state) {
      return { ...state };
    },
    getRealtimeStatsSuccess(state, action) {
      return { ...state, realtimeStats: action.payload };
    },
    getHourlyStatsRequest(state) {
      return { ...state, isLoading: true };
    },
    getHourlyStatsSuccess(state, action) {
      return { ...state, isLoading: false, hourlyStats: action.payload };
    },
    getDailyStatsRequest(state) {
      return { ...state, isLoading: true };
    },
    getDailyStatsSuccess(state, action) {
      return { ...state, isLoading: false, dailyStats: action.payload };
    },
    getMonthlyStatsRequest(state) {
      return { ...state, isLoading: true };
    },
    getMonthlyStatsSuccess(state, action) {
      return { ...state, isLoading: false, monthlyStats: action.payload };
    },
    getPeakHoursRequest(state) {
      return { ...state, isLoading: true };
    },
    getPeakHoursSuccess(state, action) {
      return { ...state, isLoading: false, peakHours: action.payload };
    },
    getHeatmapStatsRequest(state) {
      return { ...state, isLoading: true };
    },
    getHeatmapStatsSuccess(state, action) {
      return { ...state, isLoading: false, heatmapStats: action.payload };
    },
    getOnlineUsersRequest(state) {
      return { ...state };
    },
    getOnlineUsersSuccess(state, action) {
      const { admins, users } = action.payload;
      return {
        ...state,
        onlineAdmins: admins.docs,
        onlineUsers: users.docs,
        onlineAdminTotal: admins.totalDocs,
        onlineUserTotal: users.totalDocs,
      };
    },
    stopLoading(state) {
      return { ...state, isLoading: false };
    },
  },
});

export const {
  getRealtimeStatsRequest,
  getRealtimeStatsSuccess,
  getHourlyStatsRequest,
  getHourlyStatsSuccess,
  getDailyStatsRequest,
  getDailyStatsSuccess,
  getMonthlyStatsRequest,
  getMonthlyStatsSuccess,
  getPeakHoursRequest,
  getPeakHoursSuccess,
  getHeatmapStatsRequest,
  getHeatmapStatsSuccess,
  getOnlineUsersRequest,
  getOnlineUsersSuccess,
  stopLoading,
} = userActivitySlice.actions;

export default userActivitySlice.reducer;
